var debounce = require('../util/_debounce');

var modalLinks = document.querySelectorAll('a[data-modal]');
for (var i = 0, len = modalLinks.length; i < len; i++) {
  var modalLink = modalLinks[i];
  modalLink.addEventListener('click', modalOpen);
}

function modalOpen(event) {
  modalInject(this);
  modalHeight();
  if (event.preventDefault) {
    event.preventDefault();
  } else {
    event.returnValue = false;
  }
}

function modalInject(item) {
  var modalDOM = document.createElement('div');
  modalDOM.innerHTML = modalTemplate(item);
  document.querySelector('body').appendChild(modalDOM.firstChild);
  modalCloseSetup();
}

function modalTemplate(item) {
  var modalURL = item.getAttribute('href');
  var modalContent;
  if (modalURL.indexOf('youtube.com/') > -1) {
    var id = youtubeID(modalURL);
    modalContent = '<div class="modal__item"><div class="modal__video"><iframe class="modal__video__embed" src="https://www.youtube.com/embed/' + id + '?autoplay=0" frameborder="0" allowfullscreen></iframe></div></div>';
  } else {
    modalContent = '<img class="modal__item" src="' + modalURL + '" />';
  }
  return '<div class="modal"><div class="modal__overlay"></div><div class="modal__container">' + modalContent + '</div></div>';
}

function modalHeight() {
  var item = document.querySelector('.modal__item');
  if (item) {
    var winHeight = window.innerHeight;
    var container = document.querySelector('.modal__container');
    var video = document.querySelector('.modal__video');
    var paddingTop = parseInt(getComputedStyle(container).getPropertyValue('padding-top'), 10);
    var paddingBottom = parseInt(getComputedStyle(container).getPropertyValue('padding-bottom'), 10);
    var padding = paddingTop + paddingBottom;
    if (video) {
      item.style.maxWidth = ((winHeight - padding) * (16/9)) + 'px';
    } else {
      item.style.maxHeight = (winHeight - padding) + 'px';
    }
  }
}

function modalCloseSetup() {
  var modal = document.querySelector('.modal');
  var item = document.querySelector('.modal__item');
  modal.addEventListener('click', function(e) {
    if (!item.contains(e.target)) {
      modal.classList.add('modal--remove');
      setTimeout(function() {
        modal.parentNode.removeChild(modal);
      }, 320);
    }
  });
}

function youtubeID(url) {
  var id = url.split('v=')[1];
  var amp = id.indexOf('&');
  if (amp != -1) {
    id = id.substring(0, amp);
  }
  return id;
}

window.addEventListener('resize', debounce(modalHeight, 100));
